import { c as _c } from "react/compiler-runtime";
import './index.css';
import { Provider } from 'inversify-react';
import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { container } from './app-container';
import { KeyboardAnalysisProvider } from './contexts/keyboard-analysis-context';
import { KeyboardProvider } from './contexts/keyboard-context';
import { NewProfileDialogProvider } from './contexts/new-profile-dialog-context';
import { NewProfileDialog } from './components/new-profile/NewProfileDialog';
import { AppRouter } from './components/AppRouter';
import { useCreateNewProfileUseCase } from './hooks/profile/use-create-new-profile-use-case';
import { Toaster } from './components/ui/sonner';
import { ThemeProvider } from './components/theme/ThemeProvider';
const AppContent = t0 => {
  const $ = _c(6);
  const {
    isNewProfileDialogOpen,
    setIsNewProfileDialogOpen
  } = t0;
  const {
    handleCreateNewProfile
  } = useCreateNewProfileUseCase();
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AppRouter />;
    t2 = <Toaster position="top-center" richColors={true} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== handleCreateNewProfile || $[3] !== isNewProfileDialogOpen || $[4] !== setIsNewProfileDialogOpen) {
    t3 = <>{t1}{t2}<NewProfileDialog isOpen={isNewProfileDialogOpen} onOpenChange={setIsNewProfileDialogOpen} onConfirm={handleCreateNewProfile} /></>;
    $[2] = handleCreateNewProfile;
    $[3] = isNewProfileDialogOpen;
    $[4] = setIsNewProfileDialogOpen;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const App = () => {
  const $ = _c(2);
  const [isNewProfileDialogOpen, setIsNewProfileDialogOpen] = useState(false);
  let t0;
  if ($[0] !== isNewProfileDialogOpen) {
    t0 = <ThemeProvider><Provider container={container}><KeyboardProvider><KeyboardAnalysisProvider><NewProfileDialogProvider onOpenChange={setIsNewProfileDialogOpen}><BrowserRouter><AppContent isNewProfileDialogOpen={isNewProfileDialogOpen} setIsNewProfileDialogOpen={setIsNewProfileDialogOpen} /></BrowserRouter></NewProfileDialogProvider></KeyboardAnalysisProvider></KeyboardProvider></Provider></ThemeProvider>;
    $[0] = isNewProfileDialogOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};